<script setup lang="ts">
import { PropType, ref } from "vue";
import MenuContent from "./MenuContent.vue";
import Category from "../model/category";

const props = defineProps({
  category: {
    type: Object as PropType<Category>,
    required: true,
  }
});

const iconMenuClass = ref("");

const showMenu = ref(false);

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
  iconMenuClass.value = showMenu.value ? "-rotate-180" : "";
};
</script>

<template>
  <!-- Bouton du menu mobile épuré -->
  <button
    class="
      xl:hidden
      z-50
      mt-2
      w-full
      bg-white
      dark:bg-gray-800
      border
      border-gray-300
      dark:border-gray-700
      text-gray-900
      dark:text-gray-100
      text-sm
      font-medium
      rounded-lg
      px-4
      py-2.5
      flex
      items-center
      justify-between
      hover:bg-gray-50
      dark:hover:bg-gray-700
      transition-colors
      duration-150
    "
    @click="toggleMenu"
  >
    <span>Navigation rapide</span>

    <!-- Icône d'expansion -->
    <fa
      :icon="['far', 'angle-down']"
      class="
        transition-transform
        duration-200
        text-sm
      "
      :class="iconMenuClass"
    />
  </button>

  <!-- Menu déroulant -->
  <transition name="slide">
    <div
      class="
        xl:hidden
        z-50
        origin-top
        bg-white
        dark:bg-gray-800
        border
        border-t-0
        border-gray-300
        dark:border-gray-700
        rounded-b-lg
        overflow-hidden
        shadow-sm
        mt-[-1px]
      "
      v-if="showMenu"
    >
      <div class="
          max-h-80
          overflow-y-auto
          py-2
          px-3
        ">
        <MenuContent v-if="props.category" :marker="props.category.d" slug="d" />
      </div>
    </div>
  </transition>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-enter-from,
.slide-leave-to {
  transform: scaleY(0);
  opacity: 0;
}
.slide-enter-to,
.slide-leave-from {
  transform: scaleY(1);
  opacity: 1;
}
</style>
